module.exports = {"540625100":"申扎镇","540625101":"雄梅镇","540625201":"下过乡","540625202":"卡乡","540625203":"巴扎乡","540625204":"塔尔玛乡","540625206":"买巴乡","540625207":"马跃乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540625.json
// module id = 2740
// module chunks = 0